import { hideLoading } from "components/Loading";
import { showLoading } from "components/Loading";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { Button, Input, Modal, ModalBody, Table } from "reactstrap";
import ordemServicoService, { StatusOrdemServicoEnum } from "services/OrdemServicoService";
import { erroInesperado } from "services/Utils";
import { onlyNumbers } from "services/Utils";
import {  formatNumber } from "services/Utils";

export default function ModalAlterar({ config, onClosed, onChange }) {
  const [data, setData] = useState({})
  const [passo, setPasso] = useState(1)

  const justificativaObrigatoria = useMemo(() => {
    return config?.os?.idStatus != StatusOrdemServicoEnum.PENDENTE
  }, [config])

  const justificativaValida = useMemo(() => {
    if (!justificativaObrigatoria) return true
    return !!data.justificativa?.trim()
  }, [data.justificativa, justificativaObrigatoria])

  useEffect(() => {
    if (config) {
      setData({
        quantidade: config.selecionado.quantidade,
        quantidadeAnterior: config.selecionado.quantidade,
        justificativa: ''
      })
      setPasso(1)
    } else {
      setData({})
      setPasso(1)
    }
  }, [config])

  const handleChangeQuantidade = (quantidade) => {
    setData(data => ({ ...data, quantidade }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!justificativaValida) {
      toast('Informe a justificativa para continuar.')
      return
    }

    if (data.quantidadeAnterior != data.quantidade) {
      try {
        showLoading()
        const res = await ordemServicoService.updateItem(config.idOrdemServico, config.selecionado.id, data.quantidade, data.justificativa)
        hideLoading()

        if (res.success) {
          toast('Registro salvo com sucesso!')
          onChange && onChange()
          onClosed && onClosed()
          return
        }

        toast(res.message || 'Erro ao salvar o registro')
      } catch (ex) {
        hideLoading()
        console.error(ex)
        erroInesperado()
        return
      }
      return
    }

    onClosed && onClosed()
  }

  const handleCancelar = () => {
    onClosed && onClosed()
  }

  const handleProximoPasso = () => {
    setPasso(2)
  }

  const handlePassoAnterior = () => {
    setPasso(1)
  }

  return (
    <Modal isOpen={!!config} size="lg">
      <ModalBody>
        {config && (
          <form onSubmit={handleSubmit}>
            <h2>Alterar item</h2>
            <hr />
            {passo == 1 ? (
              <div className="row">
                <div className="col-12">
                  <Table className="align-items-center table-flush">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Descrição</th>
                        <th>Unid</th>
                        <th className="text-right">Valor Unit.</th>
                        <th className="text-right">Quantidade</th>
                        <th className="text-right">Valor Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[config.selecionado].map(el => (
                        <tr key={el.id}>
                          <td>{el.codigo}</td>
                          <td className="text-wrap">
                            {el.descricao}
                          </td>
                          <td>{el.unidade}</td>
                          <td className="text-right">R$ {el.precoUnitarioFmt}</td>
                          <td>
                            <Input type="text" value={formatNumber(data.quantidade || 0)} onChange={e => handleChangeQuantidade(parseInt(onlyNumbers(e.target.value) || 0) / 100)} />
                          </td>
                          <td className="text-right">R$ {formatNumber(el.precoUnitario * (data.quantidade || 0))}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
                  <div className="col-12 text-right">
                    <Button type="button" color="primary" onClick={handleProximoPasso} disabled={(data.quantidade || 0) <= 0}>Próximo</Button>
                  <Button color="primary" onClick={handleCancelar} outline>Cancelar</Button>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-12">
                  <div className="form-group mb-0">
                    <label htmlFor="justificativa">
                      Justificativa {justificativaObrigatoria ? '*' : '(opcional)'}
                    </label>
                    <Input
                      id="justificativa"
                      type="textarea"
                      rows={5}
                      value={data.justificativa || ''}
                      onChange={e => setData(data => ({ ...data, justificativa: e.target.value }))}
                      placeholder="Descreva o motivo da alteração"
                    />
                  </div>
                  {justificativaObrigatoria && !justificativaValida && (
                    <small className="text-danger">A justificativa é obrigatória para esta OS.</small>
                  )}
                </div>
                <div className="col-12 text-right mt-4">
                  <Button type="button" color="primary" onClick={handlePassoAnterior} outline>Voltar</Button>
                  <Button type="submit" color="primary" disabled={!justificativaValida}>Concluir</Button>
                  <Button color="primary" onClick={handleCancelar} outline>Cancelar</Button>
                </div>
              </div>
            )}
          </form>
        )}
      </ModalBody>
    </Modal>
  )
}